import axios from "axios";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";

/**
 * Axios Request Interceptor
 *
 * This Component born to set axios default parameters with interceptors.
 * - Responsibile for handling Accept Language header
 * - Responsible for forwarding a general error message to application (if server response with a class 5** error)
 *     - See also jwtService axios interceptor (for token reasons)
 *
 * It actually use this props
 * @param props {Object}
 * - Language (en,it) the i18n.language string from i18n react package
 */
const AxiosInterceptorsHandler = (props) => {

    const default_toast_duration = 1500
    const error_status = [500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 511]
    const token_expiration_error_codes = ["INVALID_ACCESS_TOKEN", "INVALID_TOKEN"]

    const [countToast, setCountToast] = useState(0)

    // const renderToastError = (response) => {
    //     if(countToast === 0) {
    //         const response_message = response.data.detail
    //         toast.error(response_message, {
    //             position: "bottom-right",
    //             autoClose: default_toast_duration,
    //             hideProgressBar: true,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //         });
    //         setCountToast(1)
    //     }
    // }

    useEffect(() => {
        // Add a request header
        axios.defaults.headers.common['Accept-Language'] = props.language
    }, [props.language])

    // useEffect(() => {
    //     axios.interceptors.response.use(
    //         (response) => response,
    //         (error) => {
    //             // ** const { config, response: { status } } = error
    //             const {config, response} = error;
    //             const originalRequest = config;
    //
    //             if (
    //                 response &&
    //                 (error_status.includes(response.status)) &&
    //                 ((response.headers['error-code'] && !token_expiration_error_codes.includes(response.headers['error-code'])) ||
    //                     (!response.headers['error-code']))
    //             ) {
    //                 renderToastError(response)
    //                 return Promise.reject(error);
    //             }
    //             return Promise.reject(error);
    //         }
    //     );
    // }, [])
    //
    // useEffect(() => {
    //     if (countToast > 0) {
    //         setTimeout(() => {
    //             setCountToast(0)
    //         }, default_toast_duration + 150)
    //     }
    // }, [countToast])

    return (
        <></>
    )
}
export default AxiosInterceptorsHandler
